import * as S from "@styles/index";

export const ROUTES = {
  MAIN: "main",
  SCHEDULE: "schedule",
  RESERVE: "reserve",
  RECOMMEND: "recommend",
  CONFIRM: "confirm",
  COMPLETE: "complete",
};

export const FONT_STR = {
  B18: "Bold18",
  B16: "Bold16",
  S26: "SemiBold26",
  S20: "SemiBold20",
  S14: "SemiBold14",
  M20: "Medium20",
  M19: "Medium19",
  M18: "Medium18",
  M17: "Medium17",
  R19: "Regular19",
  R18: "Regular18",
  R17: "Regular17",
  R16: "Regular16",
};

export const FONT_CSS = {
  [FONT_STR.B18]: S.Bold18,
  [FONT_STR.B16]: S.Bold16,
  [FONT_STR.S26]: S.SemiBold26,
  [FONT_STR.S20]: S.SemiBold20,
  [FONT_STR.S14]: S.SemiBold14,
  [FONT_STR.M20]: S.Medium20,
  [FONT_STR.M18]: S.Medium18,
  [FONT_STR.M19]: S.Medium19,
  [FONT_STR.M17]: S.Medium17,
  [FONT_STR.R19]: S.Regular19,
  [FONT_STR.R18]: S.Regular18,
  [FONT_STR.R17]: S.Regular17,
  [FONT_STR.R16]: S.Regular16,
};
